// import React, { useEffect, useState, useCallback } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { toast } from "react-toastify";
// import "../css/TourProgram.css";
// import { BASE_URL } from "../config";
// import { getAuthHeaders } from "../services/useAuth";
// import Loader from "../dist/Loader";
// import { formatDate } from "../utils/formatDate";
// import CustomButton from "./CustomButton";
// import { showErrorToast } from "../dist/Toaster";
// const months = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];
// // ── Helpers ────────────────────────────────────────────────────────────────
// const getCurrentMonthYear = () => {
//   const date = new Date();
//   return `${months[date.getMonth()]} ${date.getFullYear()}`;
// };
// const generateMonthYearOptions = () => {
//   const options = [];
//   const currentDate = new Date();
//   const pastMonths = 10;
//   const futureMonths = 2;
//   for (let i = futureMonths; i >= -pastMonths; i--) {
//     const date = new Date(
//       currentDate.getFullYear(),
//       currentDate.getMonth() + i,
//       1,
//     );
//     options.push(`${months[date.getMonth()]} ${date.getFullYear()}`);
//   }
//   return options;
// };

// const parseMonthYear = (value) => {
//   if (!value || typeof value !== "string") return null;
//   const [monthName, yearStr] = value.trim().split(" ");
//   const normalized = monthName === "Sept" ? "Sep" : monthName;
//   const monthIndex = months.indexOf(normalized);
//   const year = Number(yearStr);
//   if (monthIndex === -1 || !Number.isFinite(year)) return null;
//   return { month: monthIndex + 1, year };
// };
// // ──────────────────────────────────────────────────────────────────────────

// const ExecutiveTourProgram = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [states, setStates] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedDivision, setSelectedDivision] = useState("");
//   const [selectedMonthYear, setSelectedMonthYear] =
//     useState(getCurrentMonthYear);

//   const [showTable, setShowTable] = useState(false);
//   const [tourPrograms, setTourPrograms] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);

//   // Derived — always in sync with selectedMonthYear, never undefined
//   const parsedMonthYear = parseMonthYear(selectedMonthYear);
//   const selectedMonth = parsedMonthYear?.month ?? null;
//   const selectedYear = parsedMonthYear?.year ?? null;

//   // ── Fetch states ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchStates = async () => {
//       try {
//         const response = await fetch(`${BASE_URL}/api/states`, {
//           headers: getAuthHeaders(),
//         });
//         const data = await response.json();
//         setStates(data);
//       } catch (err) {
//         console.error("State fetch error:", err);
//       }
//     };
//     fetchStates();
//   }, []);

//   // ── Fetch divisions when state changes ───────────────────────────────────
//   useEffect(() => {
//     if (!selectedState) {
//       setDivisions([]);
//       setSelectedDivision("");
//       return;
//     }
//     const fetchDivisions = async () => {
//       try {
//         const response = await fetch(
//           `${BASE_URL}/api/divisions?state=${selectedState}`,
//           { headers: getAuthHeaders() },
//         );
//         const data = await response.json();
//         setDivisions(data);
//       } catch (err) {
//         console.error("Division fetch error:", err);
//       }
//     };
//     fetchDivisions();
//   }, [selectedState]);

//   // ── Restore preserved state on back-navigation ───────────────────────────
//   useEffect(() => {
//     if (!location.state?.preservedState) return;
//     const {
//       selectedState: ps_state,
//       selectedDivision: ps_div,
//       selectedMonthYear: ps_my,
//       selectedMonth: ps_month,
//       selectedYear: ps_year,
//       showTable: ps_show,
//       tourPrograms: ps_programs,
//     } = location.state.preservedState;
//     if (ps_state) setSelectedState(ps_state);
//     if (ps_div) setSelectedDivision(ps_div);
//     if (ps_show) setShowTable(ps_show);

//     if (ps_my) {
//       setSelectedMonthYear(ps_my);
//     } else if (ps_month && ps_year) {
//       setSelectedMonthYear(`${months[ps_month - 1]} ${ps_year}`);
//     }

//     if (ps_programs) setTourPrograms(ps_programs);
//   }, [location.state]);

//   // ── Clean up history state on unmount ────────────────────────────────────
//   useEffect(() => {
//     return () => {
//       window.history.replaceState({}, document.title);
//     };
//   }, []);

//   // ── Handlers ──────────────────────────────────────────────────────────────
//   const handleMonthYearChange = useCallback((value) => {
//     // Validate before setting — ignore invalid selections
//     if (parseMonthYear(value)) {
//       setSelectedMonthYear(value);
//     }
//   }, []);

//   const handleGoClick = useCallback(async () => {
//     if (!selectedState) {
//       toast.warning("Please select a State");
//       return;
//     }

//     // Guard: month/year must be valid before making the API call
//     if (!selectedMonth || !selectedYear) {
//       toast.warning("Please select a valid Month/Year");
//       return;
//     }

//     setShowTable(true);
//     setIsLoading(true);

//     try {
//       const params = new URLSearchParams();
//       params.append("state_id", selectedState);
//       if (selectedDivision) params.append("division_id", selectedDivision);

//       // Always build from derived selectedMonth/selectedYear — guaranteed valid
//       const monthYearParam = `${months[selectedMonth - 1]} ${selectedYear}`;
//       params.append("monthYear", monthYearParam);

//       const response = await fetch(
//         `${BASE_URL}/api/tour-programs/tour-details?${params.toString()}`,
//         { headers: getAuthHeaders() },
//       );

//       if (!response.ok) throw new Error("Failed to fetch tour details.");

//       const tourData = await response.json();
//       setTourPrograms(tourData);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       alert(`Error fetching tour details: ${error.message}`);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [selectedState, selectedDivision, selectedMonth, selectedYear]);

//   const handleApproveViewClick = useCallback(
//     (employee) => {
//       navigate("/addtour-program", {
//         state: {
//           employeeData: {
//             id: employee.emp_id,
//             name: employee.emp_name,
//             designation: employee.desi,
//             role: employee.role,
//             headquarter: employee.hq,
//             state: employee.state,
//             division: employee.div,
//             selectedMonth,
//             selectedYear,
//             final_joining_date: employee.doj,
//           },
//           preservedState: {
//             selectedState,
//             selectedDivision,
//             selectedMonthYear,
//             selectedMonth,
//             selectedYear,
//             showTable: true,
//             tourPrograms,
//           },
//           isNewProgram: false,
//         },
//       });
//     },
//     [
//       navigate,
//       selectedMonth,
//       selectedYear,
//       selectedState,
//       selectedDivision,
//       selectedMonthYear,
//       tourPrograms,
//     ],
//   );

//   const handleAddTourProgram = useCallback(
//     (employee) => {
//       navigate("/addtour-program", {
//         state: {
//           employeeData: {
//             id: employee.emp_id,
//             name: employee.emp_name,
//             designation: employee.desi,
//             role: employee.role,
//             headquarter: employee.hq,
//             state: employee.state,
//             division: employee.div,
//             selectedMonth,
//             selectedYear,
//             final_joining_date: employee.doj,
//           },
//           preservedState: {
//             selectedState,
//             selectedDivision,
//             selectedMonthYear,
//             selectedMonth,
//             selectedYear,
//             showTable: true,
//             tourPrograms,
//           },
//           isNewProgram: true,
//         },
//       });
//     },
//     [
//       navigate,
//       selectedMonth,
//       selectedYear,
//       selectedState,
//       selectedDivision,
//       selectedMonthYear,
//       tourPrograms,
//     ],
//   );

//   const handleDeleteTourProgram = useCallback(
//     async (employeeId) => {
//       if (!selectedMonth || !selectedYear) {
//         showErrorToast(
//           "Month or Year is not selected. Please reselect and try again.",
//         );
//         return;
//       }

//       if (
//         !window.confirm(
//           `Are you sure you want to delete the ${selectedMonthYear} tour program for this employee?`,
//         )
//       ) {
//         return;
//       }

//       setIsLoading(true);
//       try {
//         const response = await fetch(
//           `${BASE_URL}/api/tour-programs/employee/${employeeId}/tour-program?month=${selectedMonth}&year=${selectedYear}`,
//           {
//             method: "DELETE",
//             headers: getAuthHeaders(),
//           },
//         );

//         if (!response.ok) {
//           const errData = await response.json().catch(() => null);
//           const errMsg = errData?.detail
//             ? Array.isArray(errData.detail)
//               ? errData.detail.map((e) => e.msg).join(", ")
//               : errData.detail
//             : errData?.message || "Failed to delete tour program.";
//           throw new Error(errMsg);
//         }

//         const result = await response.json();
//         toast.success(result.message || "Tour program deleted successfully");
//         setTourPrograms((prev) =>
//           prev.filter((emp) => emp.emp_id !== employeeId),
//         );
//       } catch (error) {
//         console.error("Error deleting tour program:", error);
//         toast.error(error.message || "Failed to delete tour program");
//       } finally {
//         setIsLoading(false);
//       }
//     },
//     [selectedMonth, selectedYear, selectedMonthYear],
//   );

//   // ── Render ─────────────────────────────────────────────────────────────────
//   return (
//     <div className="p-2 border-2 border-gray-300 rounded-lg bg-white">
//       {isLoading && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
//           <Loader onCancel={() => setIsLoading(false)} />
//         </div>
//       )}
//       <div
//         className={`main-container ${isLoading ? "blur-sm pointer-events-none" : ""}`}
//       >
//         <div className="p-4 border-2 border-gray-300 rounded-lg bg-gray-50">
//           <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
//             <span className="text-blue-700">Tour </span>
//             <span className="text-blue-500">Program</span>
//           </h1>

//           <div className="tourprogram-filter-row1">
//             <label className="tourprogram-label">State</label>
//             <select
//               className="tourprogram-dropdown"
//               value={selectedState}
//               onChange={(e) => {
//                 setSelectedState(e.target.value);
//                 setSelectedDivision("");
//               }}
//               required
//             >
//               <option value="">Select</option>
//               {states.map((state) => (
//                 <option key={state.id} value={state.id}>
//                   {state.name}
//                 </option>
//               ))}
//             </select>

//             <label className="tourprogram-label">Division</label>
//             <select
//               className="tourprogram-dropdown"
//               value={selectedDivision}
//               onChange={(e) => setSelectedDivision(e.target.value)}
//             >
//               <option value="">All</option>
//               {divisions.map((div) => (
//                 <option key={div.id} value={div.id}>
//                   {div.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="tourprogram-filter-row2">
//             <label className="tourprogram-label">Month/Year</label>
//             <select
//               className="tourprogram-dropdown"
//               value={selectedMonthYear}
//               onChange={(e) => handleMonthYearChange(e.target.value)}
//             >
//               {generateMonthYearOptions().map((opt) => (
//                 <option key={opt} value={opt}>
//                   {opt}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="tourprogram-go-button">
//             <CustomButton
//               variant="go"
//               onClick={handleGoClick}
//               disabled={isLoading}
//             >
//               {isLoading ? "Loading..." : "GO"}
//             </CustomButton>
//           </div>
//         </div>

//         {showTable && (
//           <div className="p-2 border-2 border-gray-300 rounded-lg bg-white mt-5">
//             <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
//               <span className="text-blue-700">Employee Tour </span>
//               <span className="text-blue-500">Details</span>
//             </h1>

//             {isLoading ? (
//               <p>Loading tour programs...</p>
//             ) : (
//               <div className="border rounded shadow table-wrapper">
//                 <table className="unlock-dcr-leave-table text-sm">
//                   <thead className="bg-blue-500 text-white">
//                     <tr>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         SR NO
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Emp ID
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         State
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Employee Name
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Desi
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         HQ
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Div
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         DOJ
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Mobile No
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Manager
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Approved By
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Approved Date
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Action
//                       </th>
//                       <th className="px-3 py-2 text-left text-sm font-medium text-white">
//                         Delete
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {tourPrograms.length === 0 ? (
//                       <tr>
//                         <td colSpan={14} style={{ textAlign: "center" }}>
//                           No tour program data found.
//                         </td>
//                       </tr>
//                     ) : (
//                       tourPrograms.map((emp, idx) => (
//                         <tr key={emp.emp_id}>
//                           <td className="px-3 py-2">{idx + 1}</td>
//                           <td className="px-3 py-2">{emp.employee || ""}</td>
//                           <td className="px-3 py-2">{emp.state || ""}</td>
//                           <td className="px-3 py-2">{emp.emp_name || ""}</td>
//                           <td className="px-3 py-2">{emp.desi || ""}</td>
//                           <td className="px-3 py-2">{emp.hq || ""}</td>
//                           <td className="px-3 py-2">{emp.div || ""}</td>
//                           <td className="px-3 py-2">
//                             {formatDate(emp.doj) || emp.doj}
//                           </td>
//                           <td className="px-3 py-2">{emp.mobile_no || ""}</td>
//                           <td className="px-3 py-2">{emp.manager || ""}</td>
//                           <td className="px-3 py-2">{emp.approved_by || ""}</td>
//                           <td className="px-3 py-2">
//                             {formatDate(emp.approved_date)}
//                           </td>
//                           <td className="px-3 py-2">
//                             {emp.status ? (
//                               <button
//                                 className="approve-view-btn"
//                                 onClick={() => handleApproveViewClick(emp)}
//                               >
//                                 View
//                               </button>
//                             ) : (
//                               <button
//                                 className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-3 rounded w-18"
//                                 onClick={() => handleAddTourProgram(emp)}
//                               >
//                                 Add
//                               </button>
//                             )}
//                           </td>
//                           <td className="px-3 py-2">
//                             <button
//                               className="bg-red-600 hover:bg-red-700 text-white font-semibold py-1 px-3 rounded w-24"
//                               onClick={() =>
//                                 handleDeleteTourProgram(emp.emp_id)
//                               }
//                             >
//                               Delete
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ExecutiveTourProgram;

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "../css/TourProgram.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import Loader from "../dist/Loader";
import { formatDate } from "../utils/formatDate";
import CustomButton from "./CustomButton";
import { showErrorToast } from "../dist/Toaster";

const months = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// ── Helpers ────────────────────────────────────────────────────────────────
const getCurrentMonthYear = () => {
  const date = new Date();
  return `${months[date.getMonth()]} ${date.getFullYear()}`;
};

const generateMonthYearOptions = () => {
  const options = [];
  const currentDate = new Date();
  const pastMonths = 10;
  const futureMonths = 2;
  for (let i = futureMonths; i >= -pastMonths; i--) {
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth() + i, 1);
    options.push(`${months[date.getMonth()]} ${date.getFullYear()}`);
  }
  return options;
};

const parseMonthYear = (value) => {
  if (!value || typeof value !== "string") return null;
  const [monthName, yearStr] = value.trim().split(" ");
  const normalized = monthName === "Sept" ? "Sep" : monthName;
  const monthIndex = months.indexOf(normalized);
  const year = Number(yearStr);
  if (monthIndex === -1 || !Number.isFinite(year)) return null;
  return { month: monthIndex + 1, year };
};
// ──────────────────────────────────────────────────────────────────────────

const ExecutiveTourProgram = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [states, setStates] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedMonthYear, setSelectedMonthYear] = useState(getCurrentMonthYear);

  const [showTable, setShowTable] = useState(false);
  const [tourPrograms, setTourPrograms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Derived — always in sync with selectedMonthYear, never undefined
  const parsedMonthYear = parseMonthYear(selectedMonthYear);
  const selectedMonth = parsedMonthYear?.month ?? null;
  const selectedYear = parsedMonthYear?.year ?? null;

  // ── Fetch states ──────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/states`, {
          headers: getAuthHeaders(),
        });
        const data = await response.json();
        setStates(data);
      } catch (err) {
        console.error("State fetch error:", err);
      }
    };
    fetchStates();
  }, []);

  // ── Fetch divisions when state changes ───────────────────────────────────
  useEffect(() => {
    if (!selectedState) {
      setDivisions([]);
      setSelectedDivision("");
      return;
    }
    const fetchDivisions = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/divisions?state=${selectedState}`,
          { headers: getAuthHeaders() },
        );
        const data = await response.json();
        setDivisions(data);
      } catch (err) {
        console.error("Division fetch error:", err);
      }
    };
    fetchDivisions();
  }, [selectedState]);

  // ── Restore preserved state on back-navigation ───────────────────────────
  useEffect(() => {
    if (!location.state?.preservedState) return;
    const {
      selectedState: ps_state,
      selectedDivision: ps_div,
      selectedMonthYear: ps_my,
      selectedMonth: ps_month,
      selectedYear: ps_year,
      showTable: ps_show,
      tourPrograms: ps_programs,
    } = location.state.preservedState;
    if (ps_state) setSelectedState(ps_state);
    if (ps_div) setSelectedDivision(ps_div);
    if (ps_show) setShowTable(ps_show);
    if (ps_my) {
      setSelectedMonthYear(ps_my);
    } else if (ps_month && ps_year) {
      setSelectedMonthYear(`${months[ps_month - 1]} ${ps_year}`);
    }
    if (ps_programs) setTourPrograms(ps_programs);
  }, [location.state]);

  // ── Clean up history state on unmount ────────────────────────────────────
  useEffect(() => {
    return () => {
      window.history.replaceState({}, document.title);
    };
  }, []);

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleMonthYearChange = useCallback((value) => {
    if (parseMonthYear(value)) {
      setSelectedMonthYear(value);
    }
  }, []);

  // ── DEFINED FIRST so handleDisapproveTourProgram can reference it ─────────
  const handleGoClick = useCallback(async () => {
    if (!selectedState) {
      toast.warning("Please select a State");
      return;
    }
    if (!selectedMonth || !selectedYear) {
      toast.warning("Please select a valid Month/Year");
      return;
    }

    setShowTable(true);
    setIsLoading(true);

    try {
      const params = new URLSearchParams();
      params.append("state_id", selectedState);
      if (selectedDivision) params.append("division_id", selectedDivision);
      const monthYearParam = `${months[selectedMonth - 1]} ${selectedYear}`;
      params.append("monthYear", monthYearParam);

      const response = await fetch(
        `${BASE_URL}/api/tour-programs/tour-details?${params.toString()}`,
        { headers: getAuthHeaders() },
      );

      if (!response.ok) throw new Error("Failed to fetch tour details.");

      const tourData = await response.json();
      setTourPrograms(tourData);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(`Error fetching tour details: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  }, [selectedState, selectedDivision, selectedMonth, selectedYear]);

  const handleApproveViewClick = useCallback(
    (employee) => {
      navigate("/addtour-program", {
        state: {
          employeeData: {
            id: employee.emp_id,
            name: employee.emp_name,
            designation: employee.desi,
            role: employee.role,
            headquarter: employee.hq,
            state: employee.state,
            division: employee.div,
            selectedMonth,
            selectedYear,
            final_joining_date: employee.doj,
          },
          preservedState: {
            selectedState,
            selectedDivision,
            selectedMonthYear,
            selectedMonth,
            selectedYear,
            showTable: true,
            tourPrograms,
          },
          isNewProgram: false,
        },
      });
    },
    [navigate, selectedMonth, selectedYear, selectedState, selectedDivision, selectedMonthYear, tourPrograms],
  );

  const handleAddTourProgram = useCallback(
    (employee) => {
      navigate("/addtour-program", {
        state: {
          employeeData: {
            id: employee.emp_id,
            name: employee.emp_name,
            designation: employee.desi,
            role: employee.role,
            headquarter: employee.hq,
            state: employee.state,
            division: employee.div,
            selectedMonth,
            selectedYear,
            final_joining_date: employee.doj,
          },
          preservedState: {
            selectedState,
            selectedDivision,
            selectedMonthYear,
            selectedMonth,
            selectedYear,
            showTable: true,
            tourPrograms,
          },
          isNewProgram: true,
        },
      });
    },
    [navigate, selectedMonth, selectedYear, selectedState, selectedDivision, selectedMonthYear, tourPrograms],
  );

  const handleDeleteTourProgram = useCallback(
    async (employeeId) => {
      if (!selectedMonth || !selectedYear) {
        showErrorToast("Month or Year is not selected. Please reselect and try again.");
        return;
      }
      if (!window.confirm(`Are you sure you want to delete the ${selectedMonthYear} tour program for this employee?`)) {
        return;
      }

      setIsLoading(true);
      try {
        const response = await fetch(
          `${BASE_URL}/api/tour-programs/employee/${employeeId}/tour-program?month=${selectedMonth}&year=${selectedYear}`,
          { method: "DELETE", headers: getAuthHeaders() },
        );

        if (!response.ok) {
          const errData = await response.json().catch(() => null);
          const errMsg = errData?.detail
            ? Array.isArray(errData.detail)
              ? errData.detail.map((e) => e.msg).join(", ")
              : errData.detail
            : errData?.message || "Failed to delete tour program.";
          throw new Error(errMsg);
        }

        const result = await response.json();
        toast.success(result.message || "Tour program deleted successfully");
        setTourPrograms((prev) => prev.filter((emp) => emp.emp_id !== employeeId));
      } catch (error) {
        console.error("Error deleting tour program:", error);
        toast.error(error.message || "Failed to delete tour program");
      } finally {
        setIsLoading(false);
      }
    },
    [selectedMonth, selectedYear, selectedMonthYear],
  );

  // ── Disapprove — defined AFTER handleGoClick to avoid forward reference ───
  const handleDisapproveTourProgram = useCallback(
    async (employee) => {
      if (!selectedMonth || !selectedYear) {
        showErrorToast("Month or Year is not selected. Please reselect and try again.");
        return;
      }
      if (!window.confirm(`Are you sure you want to disapprove the ${selectedMonthYear} tour program for ${employee.emp_name}?`)) {
        return;
      }

      setIsLoading(true);
      try {
        const monthYearParam = `${months[selectedMonth - 1]} ${selectedYear}`;
        const payload = {
          monthYear: monthYearParam,
          status: "disapproved",
          remarks: "",
        };

        const response = await fetch(
          `${BASE_URL}/api/tour-programs/employee/${employee.emp_id}/approve`,
          {
            method: "PUT",
            headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        if (!response.ok) {
          const errData = await response.json().catch(() => null);
          const errMsg = errData?.detail
            ? Array.isArray(errData.detail)
              ? errData.detail.map((e) => e.msg).join(", ")
              : errData.detail
            : errData?.message || "Failed to disapprove tour program.";
          throw new Error(errMsg);
        }

        toast.success("Tour program disapproved successfully");

        // Refresh table — inline fetch, same logic as handleGoClick
        const params = new URLSearchParams();
        params.append("state_id", selectedState);
        if (selectedDivision) params.append("division_id", selectedDivision);
        params.append("monthYear", monthYearParam);

        const refreshResponse = await fetch(
          `${BASE_URL}/api/tour-programs/tour-details?${params.toString()}`,
          { headers: getAuthHeaders() },
        );
        if (refreshResponse.ok) {
          const tourData = await refreshResponse.json();
          setTourPrograms(tourData);
        }
      } catch (error) {
        console.error("Error disapproving tour program:", error);
        toast.error(error.message || "Failed to disapprove tour program");
      } finally {
        setIsLoading(false);
      }
    },
    [selectedMonth, selectedYear, selectedMonthYear, selectedState, selectedDivision],
  );

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <div className="p-2 border-2 border-gray-300 rounded-lg bg-white">
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
          <Loader onCancel={() => setIsLoading(false)} />
        </div>
      )}
      <div className={`main-container ${isLoading ? "blur-sm pointer-events-none" : ""}`}>
        <div className="p-4 border-2 border-gray-300 rounded-lg bg-gray-50">
          <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
            <span className="text-blue-700">Tour </span>
            <span className="text-blue-500">Program</span>
          </h1>

          <div className="tourprogram-filter-row1">
            <label className="tourprogram-label">State</label>
            <select
              className="tourprogram-dropdown"
              value={selectedState}
              onChange={(e) => {
                setSelectedState(e.target.value);
                setSelectedDivision("");
              }}
              required
            >
              <option value="">Select</option>
              {states.map((state) => (
                <option key={state.id} value={state.id}>{state.name}</option>
              ))}
            </select>

            <label className="tourprogram-label">Division</label>
            <select
              className="tourprogram-dropdown"
              value={selectedDivision}
              onChange={(e) => setSelectedDivision(e.target.value)}
            >
              <option value="">All</option>
              {divisions.map((div) => (
                <option key={div.id} value={div.id}>{div.name}</option>
              ))}
            </select>
          </div>

          <div className="tourprogram-filter-row2">
            <label className="tourprogram-label">Month/Year</label>
            <select
              className="tourprogram-dropdown"
              value={selectedMonthYear}
              onChange={(e) => handleMonthYearChange(e.target.value)}
            >
              {generateMonthYearOptions().map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>

          <div className="tourprogram-go-button">
            <CustomButton variant="go" onClick={handleGoClick} disabled={isLoading}>
              {isLoading ? "Loading..." : "GO"}
            </CustomButton>
          </div>
        </div>

        {showTable && (
          <div className="p-2 border-2 border-gray-300 rounded-lg bg-white mt-5">
            <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
              <span className="text-blue-700">Employee Tour </span>
              <span className="text-blue-500">Details</span>
            </h1>

            {isLoading ? (
              <p>Loading tour programs...</p>
            ) : (
              <div className="border rounded shadow table-wrapper">
                <table className="unlock-dcr-leave-table text-sm">
                  <thead className="bg-blue-500 text-white">
                    <tr>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">SR NO</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Emp ID</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">State</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Employee Name</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Desi</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">HQ</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Div</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">DOJ</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Mobile No</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Manager</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Approved By</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Approved Date</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Action</th>
                      <th className="px-3 py-2 text-left text-sm font-medium text-white">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tourPrograms.length === 0 ? (
                      <tr>
                        <td colSpan={14} style={{ textAlign: "center" }}>
                          No tour program data found.
                        </td>
                      </tr>
                    ) : (
                      tourPrograms.map((emp, idx) => (
                        <tr key={emp.emp_id}>
                          <td className="px-3 py-2">{idx + 1}</td>
                          <td className="px-3 py-2">{emp.employee || ""}</td>
                          <td className="px-3 py-2">{emp.state || ""}</td>
                          <td className="px-3 py-2">{emp.emp_name || ""}</td>
                          <td className="px-3 py-2">{emp.desi || ""}</td>
                          <td className="px-3 py-2">{emp.hq || ""}</td>
                          <td className="px-3 py-2">{emp.div || ""}</td>
                          <td className="px-3 py-2">{formatDate(emp.doj) || emp.doj}</td>
                          <td className="px-3 py-2">{emp.mobile_no || ""}</td>
                          <td className="px-3 py-2">{emp.manager || ""}</td>
                          <td className="px-3 py-2">{emp.approved_by || ""}</td>
                          <td className="px-3 py-2">{formatDate(emp.approved_date)}</td>

                          {/* ── Action column ── */}
                          <td className="px-3 py-2">
                            {emp.status ? (
                              <div className="flex gap-1">
                                <button
                                  className="approve-view-btn"
                                  onClick={() => handleApproveViewClick(emp)}
                                >
                                  View
                                </button>
                                <button
                                  className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-1 px-3 rounded"
                                  onClick={() => handleDisapproveTourProgram(emp)}
                                >
                                  Disapprove
                                </button>
                              </div>
                            ) : (
                              <button
                                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-1 px-3 rounded w-18"
                                onClick={() => handleAddTourProgram(emp)}
                              >
                                Add
                              </button>
                            )}
                          </td>

                          {/* ── Delete column ── */}
                          <td className="px-3 py-2">
                            <button
                              className="bg-red-600 hover:bg-red-700 text-white font-semibold py-1 px-3 rounded w-24"
                              onClick={() => handleDeleteTourProgram(emp.emp_id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExecutiveTourProgram;
